


































































import Vue from "vue";
import BaseFiltered from "@/app/shared/components/base/BaseFiltered.vue";

export default Vue.extend({
  name: "BaseVideo",
  components: {
    BaseFiltered,
  },
  data: function () {
    return {
      // currentTime: 0,
      videoTimeIntervalListner: null,
      bottomRightStyle: null,
      leftTopStyle: null,
    };
  },
  computed: {},
  watch: {
    glitch: function () {
      const K_GLITCH = 1.7;
      this.leftTopStyle = {
        opacity: this.glitch / K_GLITCH,
        height: `${100 + this.glitch}%`,
        width: `${100 + this.glitch}%`,
        top: `${-this.glitch}%`,
        left: `${-this.glitch}%`,
      };

      this.bottomRightStyle = {
        opacity: this.glitch / K_GLITCH,
        height: `${100 + this.glitch}%`,
        width: `${100 + this.glitch}%`,
        top: `${0}%`,
        left: `${0}%`,
      };
    },
  },
  mounted() {},
  props: {
    typeVideo: {
      type: String,
      default: "main",
    },
    muted: {
      type: Boolean,
      default: "false",
    },
    src: {
      type: String,
      required: true,
    },
    additionalStyle: {
      type: Array,
      default: null,
    },
    glitch: {
      type: Number,
      default: 0,
    },
    customFilter: {
      type: Object,
      default: null,
    },
  },
  methods: {
    onPlayVideo() {
      clearInterval(this.videoTimeIntervalListner);
      this.videoTimeIntervalListner = setInterval(() => {
        if (!this.$refs.video) {
          clearInterval(this.videoTimeIntervalListner);
        } else {
          this.onTimeUpdate();
        }
      }, 40);
    },
    onPauseVideo() {
      clearInterval(this.videoTimeIntervalListner);
    },
    onTimeUpdate() {
      this.$emit("onTimeUpdate");

      this.syncVideos();
    },
    setCurrentTime(time) {
      this.$refs.video.currentTime = time;

      if (this.isRenderedGlitch()) {
        this.setCurrentTimeGlitch(time);
      }
    },
    getCurrentTime() {
      return !this.$refs.video ? 0 : this.$refs.video.currentTime;
    },
    setVolume(volume) {
      this.$refs.video.volume = volume;
    },
    getVolume() {
      return !this.$refs.volume ? 0 : this.$refs.video.volume;
    },
    setPlaybackRate(playbackRate) {
      this.$refs.video.playbackRate = playbackRate;

      if (this.isRenderedGlitch()) {
        this.setPlaybackRateGlitch(playbackRate);
      }
    },
    getPlaybackRate() {
      return !this.$refs.video ? 1 : this.$refs.video.playbackRate;
    },
    play() {
      this.$refs.video.play();

      if (this.isRenderedGlitch()) {
        this.playGlitch();
      }
    },
    pause() {
      this.$refs.video.pause();

      if (this.isRenderedGlitch()) {
        this.pauseGlitch();
      }
    },
    isPaused() {
      return this.$refs.video.paused;
    },
    isRendered() {
      return !!this.$refs.video;
    },
    getBoundingClientRect() {
      return this.$refs.video.getBoundingClientRect();
    },
    syncVideos() {
      if (this.glitch > 0 && this.isRenderedGlitch()) {
        let ct = !this.isRendered() ? 0 : this.getCurrentTime();
        if (!!this.$refs.firstChannelVideo) {
          if (this.isPaused()) {
            this.$refs.firstChannelVideo.pause();
          } else {
            if (this.$refs.firstChannelVideo.paused) {
              this.$refs.firstChannelVideo.play();
            }
          }
          if (Math.abs(this.$refs.firstChannelVideo.currentTime - ct) > 0.5) {
            this.$refs.firstChannelVideo.currentTime = ct;
          }
        }

        if (!!this.$refs.secondChannelVideo) {
          if (this.isPaused()) {
            this.$refs.secondChannelVideo.pause();
          } else {
            if (this.$refs.secondChannelVideo.paused) {
              this.$refs.secondChannelVideo.play();
            }
          }
          if (Math.abs(this.$refs.secondChannelVideo.currentTime - ct) > 0.5) {
            this.$refs.secondChannelVideo.currentTime = ct;
          }
        }
      }
    },
    onLoadedMetaDataGlitch() {
      if (this.isRendered() && this.isRenderedGlitch() && this.isPaused()) {
        this.setCurrentTimeGlitch(this.getCurrentTime());
      }
    },
    setCurrentTimeGlitch(time) {
      this.$refs.firstChannelVideo.currentTime = time;
      this.$refs.secondChannelVideo.currentTime = time;
    },
    setPlaybackRateGlitch(playbackRate) {
      this.$refs.firstChannelVideo.playbackRate = playbackRate;
      this.$refs.secondChannelVideo.playbackRate = playbackRate;
    },
    playGlitch() {
      this.$refs.firstChannelVideo.play();
      this.$refs.secondChannelVideo.play();
    },
    pauseGlitch() {
      this.$refs.firstChannelVideo.pause();
      this.$refs.secondChannelVideo.pause();
    },
    isRenderedGlitch() {
      return !(!this.$refs.firstChannelVideo || !this.$refs.secondChannelVideo);
    },
  },
});
